<template>
    <b-container>
        <b-card no-body>
            <b-card-header>
                <i class="icon-note"></i>
                <strong>{{
                    $t('form.edit', { item: $t('ranges.range') })
                }}</strong>
            </b-card-header>
            <b-card-body>
                <Loader :loader="loader" />
                <Form
                    v-show="!loader"
                    @onSubmit="onSubmit"
                    :range="range"
                    :rangePromise="rangePromise"
                />
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import api from '@/services/api'
import i18n from '@/i18n'
import Form from './components/Form'
import { mapperRangesToAPI } from './mappers/mapperRangesToAPI'
import notification, { success, danger } from '@/lib/notification'
import { getParam as getUrlParam } from '@/lib/url'
import Loader from '@/views/components/loader'
import { getUserPermissions } from '@/services/user-permissions'

notification.init()

export default {
    name: 'New',
    components: {
        Form,
        Loader,
    },
    data() {
        return {
            id: getUrlParam('id', this),
            rangePromise: null,
            range: null,
            loader: true,
        }
    },
    mounted() {
        const {
            is_admin,
            is_target_master,
            is_local_administrator,
            is_god,
        } = getUserPermissions()
        if (
            !is_admin &&
            !is_target_master &&
            !is_local_administrator &&
            !is_god
        ) {
            this.$router.push({
                path: '/v2/pages/error/403',
            })
        }

        this.rangePromise = api
            .get(`/ranges/${this.id}`)
            .then(resp => {
                const {
                    data: { data },
                } = resp
                this.range = data
            })
            .catch(e => {
                console.log(e)
                this.notificationError()
            })
            .finally(() => {
                this.loader = false
            })
    },
    methods: {
        redirectToList() {
            this.$router.push({
                path: '/v2/target/ranges/list',
            })
        },
        onSubmit(form, onReset, isLoading) {
            isLoading(true)
            api.put(`/ranges/${this.id}`, mapperRangesToAPI(form))
                .then(() => {
                    onReset()
                    this.notificationRangeEditedSuccessfully()
                    this.redirectToList()
                })
                .catch(error => {
                    console.log(error)
                    this.notificationError()
                })
                .finally(() => {
                    isLoading(false)
                })
        },
        notificationRangeEditedSuccessfully() {
            success(
                i18n.t('notification.editedSuccessfully', {
                    item: i18n.t('ranges.range'),
                })
            )
        },
        notificationError() {
            danger()
        },
    },
}
</script>
